import router from '@/router';

export function redirectUnauthenticatedUser() {
  if (import.meta.env.DEV) {
    console.warn('Can\'t redirect to Teamworks login portal locally. Generate a login link using the axle:swap-token:generate command from your local GM API installation and use it to log in.');
    router.replace({ name: 'UnauthenticatedView' });
    return;
  };

  const redirectUrl = import.meta.env.VITE_TEAMWORKS_PORTAL_URL;
  if (!redirectUrl) throw new Error('Teamworks portal URL is not defined');

  window.location.replace(redirectUrl);
}
